import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";

export interface QCAnalyticsFilters {
  order_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
  excluded_orders: FilterValue | null;
  admin_id: FilterValue[] | null;
  qc_time: FilterValue | null;
}

export interface QCAnalyticsSelectedFilters {
  order_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: string;
  end_date: string;
  admin_id: FilterValue[] | null;
  qc_time: FilterValue | null;
  excluded_orders: FilterValue | null;
}

export interface QCAnalyticsAPIFilters {
  order_id: FilterValue[] | null;
  product_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  start_date: string;
  end_date: string;
  excluded_orders: boolean;
  admin_id: FilterValue[] | null;
  qc_time: string | null;
}

export function parseQueryParamsForQCAnalyticsFilters(
  params: QCAnalyticsFilters | null,
  query_params: URLSearchParams
): QCAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_id: params?.order_id ?? [],
    product_id: params?.product_id ?? [],
    order_type: params?.order_type ?? [],
    excluded_orders: params?.excluded_orders ?? null,
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    admin_id: params?.admin_id ?? [],
    qc_time: params?.qc_time ?? null,
  };
}
